export const environment = {
  production: false,
  apiUrl: 'https://pdmacapgap-api-dev.scicomms.roche.com',
};
